import type { BlokImage, ImageItem } from "../../storyblok/types"
import type { StaticImageData } from "next/legacy/image"

const extensions = [".svg", ".webp", ".png", ".jpg", ".jpeg"]
export function readImage(
  image: BlokImage | StaticImageData | ImageItem | string,
) {
  if (typeof image === "object" && "filename" in image) {
    // Check if it's a Cloudfront URL
    try {
      const url = new URL(image.filename)
      if (url.hostname.endsWith(".cloudfront.net")) {
        return image.filename
      }
    } catch (e) {
      // Invalid URL, continue with normal processing
    }

    const hasSpecialExtension = extensions.some((ext) =>
      image.filename.endsWith(ext),
    )
    if (hasSpecialExtension) {
      return `${image.filename}/m/`
    }
    if (image.filename.includes("/m/")) {
      return image.filename
    }

    return `${image.filename}m/`
  }

  if (typeof image === "object" && "src" in image) {
    return image.src
  }

  return image
}
